import { ReportState } from "./Enums";
import { Adjustment, BalanceSheet, Company, IncomeStatement, Location, Ownership, ReportNote, Risk, IncomeStatementFunctions, Projection } from "./index";

export class ReportVersion {

    ID: string;
    CREATED_DATE: string;
    CREATED_DATE_FORMATTED_DATE: string;
    CREATED_DATE_FORMATTED_TIME: string;
    LAST_UPDATED: string;
    MAIN: boolean;
    VERSION_NAME: string;
    VALUE: number;
    COMPLETION: number;
    BORROWER_NAME: string;
    VALUATION_DATE: string;
    IS_DCF: boolean;
    UNNAMED_SALARY: number;
    COMPANY: Company;
    FYE_DATE: string;
    RECENT_FINANCIAL_DATE: string;
    INTERIM_FUTURE_INDICATION: boolean;
    ASSISTED_REPLACEMENT_SALARY: boolean;
    ASSISTED_GM_SALARY: boolean;

    COVID_AFFECTED: boolean;
    COVID_MONTHS: number;
    COVID_ESSENTIAL: boolean;
    COVID_RESTRICTIONS: boolean;
    COVID_ADD_DEBT: boolean;

    MAX_STAGE: number;

    WEIGHTED_REVENUE: number;
    WEIGHTED_SDE: number;
    WEIGHTED_EBITDA: number;

    INCOME_STATEMENT: Array<IncomeStatement>;
    OWNERSHIP_LIST: Array<Ownership>;
    LOCATION_LIST: Array<Location>;
    ADJUSTMENT_LIST: Array<Adjustment>;
    RISK: Risk;
    BALANCE_SHEET: BalanceSheet;
    PROJECTION_LIST: Array<Projection>;
    NOTES_LIST: Array<ReportNote>;
    INCOME_STATEMENT_FUNCTIONS: IncomeStatementFunctions;

    ASSISTED_INTERIM_CALCULATION: boolean;
    WEIGHTINGS_ADVANCED: boolean;
    IS_INCREASE_PERCENTAGE: number;

    PROJECTIONS_ADVANCED: boolean;

    STATE: ReportState;
    ALG_VERSION: string;

    static parse(json: any): ReportVersion {
        if (json) {
            const rv = new ReportVersion();
            rv.ID = json.ID;
            rv.CREATED_DATE = json.CREATED_DATE;
            rv.CREATED_DATE_FORMATTED_DATE = json.CREATED_DATE_FORMATTED_DATE;
            rv.CREATED_DATE_FORMATTED_TIME = json.CREATED_DATE_FORMATTED_TIME;
            rv.LAST_UPDATED = json.LAST_UPDATED;
            rv.MAIN = json.MAIN;
            rv.VERSION_NAME = json.VERSION_NAME;
            rv.VALUE = json.VALUE;
            rv.COMPLETION = json.COMPLETION;
            rv.BORROWER_NAME = json.BORROWER_NAME;
            rv.VALUATION_DATE = json.VALUATION_DATE;
            rv.IS_DCF = json.IS_DCF;
            rv.UNNAMED_SALARY = json.UNNAMED_SALARY;

            rv.FYE_DATE = json.FYE_DATE;
            rv.RECENT_FINANCIAL_DATE = json.RECENT_FINANCIAL_DATE;
            rv.INTERIM_FUTURE_INDICATION = json.INTERIM_FUTURE_INDICATION;
            rv.ASSISTED_REPLACEMENT_SALARY = json.ASSISTED_REPLACEMENT_SALARY;
            rv.ASSISTED_GM_SALARY = json.ASSISTED_GM_SALARY;

            rv.COVID_AFFECTED = json.COVID_AFFECTED;
            rv.COVID_MONTHS = json.COVID_MONTHS;
            rv.COVID_ESSENTIAL = json.COVID_ESSENTIAL;
            rv.COVID_RESTRICTIONS = json.COVID_RESTRICTIONS;
            rv.COVID_ADD_DEBT = json.COVID_ADD_DEBT;

            rv.MAX_STAGE = json.MAX_STAGE;

            rv.WEIGHTED_REVENUE = json.WEIGHTED_REVENUE;
            rv.WEIGHTED_SDE = json.WEIGHTED_SDE;
            rv.WEIGHTED_EBITDA = json.WEIGHTED_EBITDA;

            if (json.COMPANY)
                rv.COMPANY = Company.parse(json.COMPANY);
            if (json.INCOME_STATEMENT)
                rv.INCOME_STATEMENT = IncomeStatement.parseArray(json.INCOME_STATEMENT);
            if (json.OWNERSHIP_LIST)
                rv.OWNERSHIP_LIST = Ownership.parseArray(json.OWNERSHIP_LIST);
            if (json.LOCATION_LIST)
                rv.LOCATION_LIST = Location.parseArray(json.LOCATION_LIST);
            if (json.ADJUSTMENT_LIST)
                rv.ADJUSTMENT_LIST = Adjustment.parseArray(json.ADJUSTMENT_LIST);
            if (json.RISK)
                rv.RISK = Risk.parse(json.RISK);
            if (json.NOTES_LIST)
                rv.NOTES_LIST = ReportNote.parseArray(json.NOTES_LIST);
            if (json.BALANCE_SHEET)
                rv.BALANCE_SHEET = BalanceSheet.parse(json.BALANCE_SHEET);
            if (json.INCOME_STATEMENT_FUNCTIONS)
                rv.INCOME_STATEMENT_FUNCTIONS = IncomeStatementFunctions.parse(json.INCOME_STATEMENT_FUNCTIONS);
            if (json.PROJECTION_LIST)
                rv.PROJECTION_LIST = Projection.parseArray(json.PROJECTION_LIST);

            rv.ASSISTED_INTERIM_CALCULATION = json.ASSISTED_INTERIM_CALCULATION;
            rv.WEIGHTINGS_ADVANCED = json.WEIGHTINGS_ADVANCED;
            rv.IS_INCREASE_PERCENTAGE = json.IS_INCREASE_PERCENTAGE;

            rv.PROJECTIONS_ADVANCED = json.PROJECTIONS_ADVANCED;

            rv.STATE = ReportState[<string>json.STATE];

            rv.ALG_VERSION = json.ALG_VERSION;

            return rv;
        } else { return null; }
    }

    static parseArray(json: Array<any>): Array<ReportVersion> {
        const arr = [];

        if (json)
            for (const j of json)
                if (j)
                    arr.push(ReportVersion.parse(j));

        return arr;
    }
}
